import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import './BottomModal.css';
import Img from '../starcasino/components/common/Img';

export default function BottomModal({
    isOpen,
    onClose,
    title,
    children,
    id = "xs-bottom-sheet-portal",
    containerId = "xs-modal-container"
}) {
    const [portalElement, setPortalElement] = useState(null);

    useEffect(() => {
        if (!isOpen) return;
        const masterContainer = document.getElementById(containerId);
        if (!masterContainer) {
            console.error(`Container ${containerId} non trovato.`);
            return;
        }

        let element = masterContainer.querySelector(`#${id}`);
        if (!element) {
            element = document.createElement('div');
            element.id = id;
            element.className = 'c_3';
            masterContainer.appendChild(element);
        }
        setPortalElement(element);

        const scrollTop = document.documentElement.scrollTop;
        const isIOS = document.body.classList.contains("cg_device_ios");

        document.body.classList.add('no-scroll');
        if (isIOS) {
            document.body.style.position = "fixed";
            document.body.style.width = "100%";
        }

        return () => {
            document.body.classList.remove('no-scroll');
            if (isIOS) {
                document.body.style.position = "";
                document.body.style.width = "";
                window.scrollTo(0, scrollTop);
            }
            if (element && masterContainer.contains(element)) {
                masterContainer.removeChild(element);
            }
        };
    }, [isOpen, id, containerId]);

    if (!isOpen || !portalElement) return null;

    return ReactDOM.createPortal(
        <div className="bottom-modal" role="dialog" aria-modal="true">
            <div className="bottom-modal__backdrop" onClick={onClose} />
            <div className="bottom-modal__sheet">
                <div className="bottom-modal__header">
                    <span className="bottom-modal__title">{title}</span>
                    <div className="bottom-modal__close" onClick={onClose}>
                        <Img src="close.svg" width="16px" height="16px" alt="Chiudi" />
                    </div>
                </div>
                <div className="bottom-modal__body">
                    {children}
                </div>
            </div>
        </div>,
        portalElement
    );
}